// extracted by mini-css-extract-plugin
module.exports = {"item":"review_dialog_item__1yL7K","title":"review_dialog_title__2eckZ","subTitle":"review_dialog_subTitle__MTcB7","message":"review_dialog_message__3HgRV"};